import { Component, OnInit, ViewEncapsulation , DestroyRef} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {takeUntil} from 'rxjs';
import {FuseMediaWatcherService} from 'fuseui';
import {FuseNavigationService, FuseVerticalNavigationComponent} from 'fuseui';
import {Navigation} from '../../../../../../../../apps/fuse/src/app/core/navigation/navigation.types';
import {NavigationService} from '../../../../../../../../apps/fuse/src/app/core/navigation/navigation.service';
import {UserService} from '../../../../../../../../apps/fuse/src/app/core/user/user.service';
import {UserResource} from 'libs/kfp/src';
import {AuthService} from '../../../../auth/auth.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
@Component({
    selector: 'classy-layout',
    templateUrl: './classy.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ClassyLayoutComponent implements OnInit {
    isScreenSmall?: boolean;
    navigation?: Navigation;
    user?: UserResource;
    isAdmin = false;
    /**
     * Constructor
     */
    constructor(private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _navigationService: NavigationService,
        private _userService: UserService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService,
        private _authService: AuthService, private readonly destroyRef: DestroyRef) {
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------
    /**
     * Getter for current year
     */
    get currentYear(): number {
        return new Date().getFullYear();
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------
    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to navigation data
        this._navigationService.navigation$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((navigation: Navigation) => {
                this.navigation = navigation;
            });
        // Subscribe to the user service
        this._userService.user$
            .pipe((takeUntilDestroyed(this.destroyRef)))
            .subscribe((user: UserResource) => {
                this.user = user;
            });
        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(({matchingAliases}) => {
                // Check if the screen is small
                this.isScreenSmall = !matchingAliases.includes('md');
            });
        this._authService.profile().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response: any) => {
            const roles = response.roles;
            roles.forEach((role: any) => {
                if (role.name === 'role.admin' || role.name === 'role.superadmin') {
                    this.isAdmin = true;
                }
            });
        });
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void {
        // Get the navigation
        const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(name);
        if (navigation) {
            // Toggle the opened status
            navigation.toggle();
        }
    }
    getNavigation() {
        if (this.navigation) {
            return this.isAdmin ? this.navigation.default : this.navigation.defaultNotAdmin;
        } else {
            return null;
        }
    }
    getHorizontalNavigation() {
        if (this.navigation) {
            return this.isAdmin ? this.navigation.horizontal : this.navigation.horizontalNotAdmin;
        } else {
            return null;
        }
    }
}